
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-thread",
      function () {
        return require("private-next-pages/profile-thread.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile-thread"])
      });
    }
  